<template>
  <div class="Prices">
      Page not found
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
